import React from "react";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import styles from "../../shared/subnav/CustomDropdown.module.scss";

const MarketDropdown = (props) => {
  const StyledSelect = withStyles({
    root: {
      width: 290,
      textAlign: "left",
      borderRadius: 3,
      border: "solid 1px #d8d8d8",
      backgroundColor: "white",
      fontFamily: "FordAntenna-Regular, sans-serif",
      fontSize: 14,
      lineHeight: 1.43,
      letterSpacing: 1,
      color: "#102b4e",
      paddingLeft: 10,
      height: 35,
    },
  })(Select);

  const StyledKeyboardArrowDownIcon = withStyles({
    root: {
      top: "calc(50% - 12px)",
      right: 0,
      color: "#102b4e",
      position: "absolute",
      paddingRight: 10,
      cursor: "pointer",
      pointerEvents: "none",
    },
  })(KeyboardArrowDown);

  const { updateMarket, selectedMarket, listOfMarkets, multipleDropdowns } =
    props;

  return (
    <div
      id="marketDropdown"
      className={
        !multipleDropdowns ? styles.dropdownDiv : styles.multipleDropdownsDiv
      }
    >
      <FormControl id="menu">
        <StyledSelect
          name="marketDropdown"
          id="selectMarketDropdown"
          className={styles.dropdown}
          IconComponent={() => <StyledKeyboardArrowDownIcon />}
          value={selectedMarket}
          onChange={(event) => updateMarket(event)}
        >
          {listOfMarkets &&
            listOfMarkets.map((market) => {
              return (
                <MenuItem
                  id={market}
                  key={market}
                  value={market}
                  data-testid={market}
                >
                  <p id={market} style={{ margin: "0", width: "50%" }}>
                    {market}
                  </p>
                </MenuItem>
              );
            })}
        </StyledSelect>
      </FormControl>
    </div>
  );
};

export default withTranslation("emp")(MarketDropdown);
